import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  SupervisorService,
  FiltersService
} from '../../../shared';

@Component({
  selector: 'app-supervisor-edit',
  templateUrl: './supervisor-edit.component.html',
  styleUrls: ['./supervisor-edit.component.scss']
})
export class SupervisorEditComponent implements OnInit {
  title = "EDIÇÃO DE SUPERVISOR";
  subtitle = "Utilize os campos abaixo para editar o supervisor";
  urlBack = "/panel/supervisor/list";

  providersArr;

  phone;

  editSupervisor = new FormGroup({
    cdFornecedor: new FormControl(''),
    cdsLogin: new FormControl(''),
    nmOperador: new FormControl(''),
    nrTelefone: new FormControl(''),
    dsEmail: new FormControl(''),
    dsSenha: new FormControl(''),
    cdOperador: new FormControl('')
  });

  id;

  constructor(
    private headerService: HeaderService,
    private supervisorService: SupervisorService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute,
    private filtersService: FiltersService
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Edição de supervisor');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.filtersService.listProviders().subscribe((response) => {
      this.providersArr = response['data'];
    });

    this.loadingBarService.start();

    this.supervisorService.getSupervisor(this.id).subscribe((response) => {
      this.editSupervisor.patchValue({
        cdFornecedor: response['cdFornecedor'],
        cdsLogin: response['cdsLogin'],
        nmOperador: response['nmOperador'],
        nrTelefone: response['nrTelefone'],
        dsEmail: response['dsEmail'],
        dsSenha: response['dsSenha'],
        cdOperador: response['cdOperador']
      });

      this.loadingBarService.complete();
    });
  }

  maskPhone(number) {
    if (number.length < 13) {
      this.phone = "(00) 0000-0000";
    } else if (number.length === 14) {
      this.phone = "(00) 0000-00009";
    } else {
      this.phone = "(00) 00000-0000";
    }
  }

  updateSupervisor() {
    this.loadingBarService.start();

    this.supervisorService.addSupervisor(this.editSupervisor.value).subscribe((response) => {
      this.loadingBarService.complete();

      Swal({
        type: "success",
        title: "Supervisor editado",
        text: "O supervisor será exibido na listagem",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      });
    });
  }

}
